<body>
    <table class="table2">
        <thead>
            <th class="titulo">
                Viagens Diretas <abbr style="color: #89bb01; font-weight: bold;">LCB</abbr> Extra
            </th>
        </thead>
    </table>
    <div class="table2">
        <div class="dataEbotao">
        <label for="startDate" class="meu-label">Data:</label>
        <input type="date" id="startDate" [(ngModel)]="startDate" name="startDate" class="labelInput" (ngModelChange)="aplicarFiltro()">
        <button (click)="limpaData()" class="botaoIcone">Limpar Filtro</button>
        <!-- <button (click)="editDialog('')" class="botaoIcone"><i-feather name="plus-circle"></i-feather>Adicionar
            Viagem</button> -->
        <div class="totais">
            <label class="totais">Total Fornecedores: <abbr style="color: #89bb01; font-weight: bold;">{{
                    totalFornecedores }}</abbr></label>
            <!-- <input [disabled]="true" type="text" name="totalFornecedores" [(ngModel)]="totalFornecedores" class="modal-input1"> -->
            <label class="totais">Total MU's: <abbr style="color: #89bb01; font-weight: bold;">{{ totalMU
                    }}</abbr></label>
            <!-- <input [disabled]="true" type="text" name="totalMU" [(ngModel)]="totalMU" class="modal-input1"> -->
        </div>
    </div>

        <!-- <a #downloadLink style="display: none;"></a> -->
        <div class="table2">
            <table class="tabelaPecas">
                <thead>
                    <tr>
                        <th class="auto-width">
                            Data solicitação
                        </th>
                        <th class="auto-width">
                            Horário
                        </th>
                        <th class="auto-width">
                            Horário Alterado
                        </th>
                        <th class="auto-width">
                            MP Code
                        </th>
                        <th class="auto-width">
                            MP Name
                        </th>
                        <th class="auto-width">
                            Cód. Fornecedor
                        </th>
                        <th class="auto-width">
                            Fornecedor
                        </th>    
                        <th class="auto-width">
                            Peças
                        </th>                     
                        <th class="auto-width">
                            Volumes
                        </th>
                        <th class="auto-width">
                            Local recebimento
                        </th>
                        <th class="auto-width">
                            Status
                        </th>
                        <th class="auto-width">
                            Ações
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let item of viagensDiretasExtrasFiltrados; let i = index">
                        <tr>
                            <td>{{ item.dataSolicitacao ? item.dataSolicitacao  : item.dataSolictacao  | date : 'dd/MM/yyyy' }}</td>
                            <td>{{ item.horaJanela ? item.horaJanela : item.horario }}</td>
                            <td>{{ item.horaAlterada ? item.horaAlterada : '' }}</td>
                            <td>{{ item.mpCode}}</td>
                            <td>{{ item.mpName }}</td>
                            <td>{{ item.codFronecedor }}</td>
                            <td>{{ item.fornecedor }}</td>
                            <td>
                                <div>
                                    <table>
                                        <tbody>
                                            <tr *ngIf="item.pecasCritica">
                                                <th class="auto-width">
                                                    PN
                                                </th>
                                                <th class="auto-width">
                                                    Qtd
                                                </th>
                                            </tr>
                                            <ng-container *ngFor="let pecas of item.pecasCritica">
                                                <tr>
                                                    <td class="itemPecas">{{ pecas.PN }}</td>
                                                    <td class="itemPecas">{{ pecas.quantidade }}</td>
                                                </tr>
                                            </ng-container>
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                            <td>{{ item.volumes }}</td>
                            <td>{{ item['Destino 1'] }}</td>
                            <td>{{ item.status }}</td>
                            <td>                                
                                    <i-feather name="edit" (click)="editDialog(item, i)"></i-feather>                              
                                    <i-feather name="delete" (click)="deleteItem(item.ID)"
                                    class="button-spacing"></i-feather>                                                          
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
</body>

<body>


<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'sm'" class="dialog-container">
<h3 class="modal-title">NOVA VIAGEM</h3>
<div class="modal-body">
    <!-- <div class="table2"> -->
    <form >
        <table>
            <thead>
                <tr>
                    <th class="labelInput">Data</th>
                    <th class="labelInput">Horário</th>
                    <th class="labelInput">MP Code</th>
                    <th class="labelInput">MP Name</th>
                    <th class="labelInput">Código Fornecedor</th>
                    <th class="labelInput">Nome Fornecedor</th>
                    <th class="labelInput">Peças Críticas</th>
                    <th class="labelInput">Quantidade de Volumes</th>
                    <th class="labelInput">Local Recebimento</th>
                    <th class="labelInput">Status</th>
                </tr>
            </thead>
          
            <tbody>
                <ng-container>
                    <tr>                         
                        <td >
                            <input [disabled]="true" type="date" name="dataSolicitacao" [(ngModel)]="item.dataSolicitacao" class="labelInput">
                        </td>
                        <td >
                            <input [disabled]="true" type="time" name="horaJanela" [(ngModel)]="item.horaJanela" class="labelInput">
                        </td> 
                        <td >
                            <!-- <input type="string" name="mpCode" [(ngModel)]="item.mpCode" class="inputsForm"> -->
                            <input [disabled]="desabilitado" type="string" name="mpCode" [(ngModel)]="item.mpCode" class="inputsForm" (blur)="verificarMPCode(item)">
                        </td>
                        <td >
                            <input [disabled]="desabilitado" type="string" name="mpName" [(ngModel)]="item.mpName" class="inputsForm">
                        </td>
                        <td >
                            <!-- <input type="string" name="codFronecedor" [(ngModel)]="item.codFronecedor" class="inputsForm"> -->
                            <input [disabled]="desabilitado" type="string" name="codFronecedor" [(ngModel)]="item.codFronecedor" class="inputsForm" (input)="verificarFornecedor(item)">
                        </td>
                        <td >
                            <input [disabled]="desabilitado" type="string" name="fornecedor" [(ngModel)]="item.fornecedor" class="inputsForm">
                        </td>
                        <td>
                            <table class="table2000">
                                <tr>
                                    <td>
                                        <button type="button" (click)="adicionarPecasCritica()">Adicionar
                                            Peça Critica</button>
                                    </td>
                                </tr>
                                <tr *ngFor="let peca of item.pecasCritica; let i = index">
                                    <td>
                                        <label class="modal-label">PN</label>
                                        <input type="text" name="PN{{i}}" [(ngModel)]="peca.PN"
                                            class="inputsForm">
                                    </td>
                                    <td>
                                        <label class="modal-label">Quantidade</label>
                                        <input type="text" name="quantidade{{i}}" [(ngModel)]="peca.quantidade"
                                            (focus)="selecionarTexto($event)" class="campo-input inputsForm" />
                                    </td>
                                    <td>
                                        <button type="button" (click)="removerPecasCritica(i)">Remover</button>
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td >
                            <input [disabled]="desabilitado" type="string" name="volumes" [(ngModel)]="item.volumes" class="inputsForm">
                        </td>
                        <td >
                            <input [disabled]="true" type="string" name="localRecebimento" [(ngModel)]="item.localRecebimento" class="inputsForm">
                        </td>
                        <td >
                            <input [disabled]="dialogOpen && usuarioLogado.role != '9' && usuarioLogado.role != '2'" type="string" name="status" [(ngModel)]="item.status" class="inputsForm">
                        </td>
                    </tr>
                </ng-container>
            </tbody>                
        </table>
        <div class="modal-div">
            <button class="modal-button" type="button" (click)="salvar2()">Save</button>
            <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
        </div>
    </form>
</div>
</clr-modal>
</body>

<div *ngIf="isLoading" class="spinner-overlay">
<div class="spinner">
    <mat-spinner></mat-spinner>
</div>
</div>
